__turbopack_context__.v({
  "current-price": "team-plan-price-summary-module-scss-module__OiTl1W__current-price",
  "name": "team-plan-price-summary-module-scss-module__OiTl1W__name",
  "offer-ends": "team-plan-price-summary-module-scss-module__OiTl1W__offer-ends",
  "original-price": "team-plan-price-summary-module-scss-module__OiTl1W__original-price",
  "price-row": "team-plan-price-summary-module-scss-module__OiTl1W__price-row",
  "save-badge": "team-plan-price-summary-module-scss-module__OiTl1W__save-badge",
  "summary": "team-plan-price-summary-module-scss-module__OiTl1W__summary",
  "unit": "team-plan-price-summary-module-scss-module__OiTl1W__unit",
});
